// extracted by mini-css-extract-plugin
export default {"form":"Form_form__-yd9C","input":"Form_input__apCDU","result":"Form_result__z21pX"};